// extracted by mini-css-extract-plugin
export default {"page-title":"OA4JwO"};